import React, { useContext, useEffect, useState } from "react";
import { TranslatorContext } from "../../context/Translator";
import { Row, Col, Tab, Tabs } from "react-bootstrap";
import { LegendFieldComponent, LegendTextareaComponent, IconFieldComponent, LabelFieldComponent, LabelTextareaComponent } from "../../components/fields";
import { ButtonComponent } from "../../components/elements";
import { FileUploadComponent } from "../../components"; 
import PageLayout from "../../layouts/PageLayout";
import { toast } from 'react-toastify';
import { updateAdmin } from "../../APIs/AdminRequests";
import { useParams } from "react-router-dom";
import { createRole, deleteRole, listPermissions, showRole, updateRole } from "../../APIs/RoleRequests";
import { viewRole } from "../../APIs/RoleRequests";
export default function RolePage() {
    const {id} = useParams();

    const { t } = useContext(TranslatorContext);
    const [name, setName] = useState('');
    const [permissions, setPermissions] = useState([]);
    const [rolePermissions, setRolePermissions] = useState([]);
    const [rolePermissionsIds, setRolePermissionsIds] = useState([]);

    
    useEffect(()=> {
        if(id){
            showRoleFunction();
        }
        listPermissionsFunction();
    },[]);
    const showRoleFunction = () => {
        viewRole(id).then((res)=> {
            setName(res.data.data.name);
            setRolePermissions(res.data.data.permissions);
            const permissionsIds = [];
            res.data.data.permissions.map((item) => {
                permissionsIds.push(item.id);
            });
            setRolePermissionsIds(permissionsIds);
        });
    }

    const listPermissionsFunction = () => {
        listPermissions().then((res) => {
            const groupedData = res.data.data.reduce((acc, item) => {
                const { group_name } = item;
                if (!acc[group_name]) {
                    acc[group_name] = [];
                }
                acc[group_name].push(item);
                return acc;
            }, {});
            
            setPermissions(groupedData);
        });
    }
    
    const updateRoleFunction = () => {
        updateRole(id,name,rolePermissionsIds).then((res)=> {
            const notify = () => toast.success(res.data.message);
            notify();
           
        });
    }

    const createRoleFunction = () => {
        createRole(name,rolePermissionsIds).then((res)=> {
            const notify = () => toast.success(res.data.message);
            notify();
            setTimeout(() => {
                window.history.back();
            }, 2000);
           
        });
    }

    const handleClickAction = () => {
        if(id){
            updateRoleFunction();
        }else{
            createRoleFunction();

        }
    }
    const handleDelete = () => {
        if(id){
            deleteRole(id).then((res)=> {
                const notify = () => toast.success(res.data.message);
                notify();
                setTimeout(() => {
                    window.history.back();
                }, 2000);
            });
        }
    }
    return (
        <PageLayout>
            <Row>
                <Col xl={12}>
                    <div className="mc-card">
                        <div className='mc-breadcrumb'>
                            <h3 className="mc-breadcrumb-title">{name}</h3>
                        </div>
                    </div>
                </Col>
                <Col xl={12}>
                    <div className="mc-card">

                                <div className="mc-tab-card">
                                    <Row>
                                        <Col xl={12}><LabelFieldComponent type="text" label={t('name')} fieldSize="w-100 h-md" onChange={(e)=>setName(e.target.value)} value={name}/></Col>

                                        
                                    </Row>
                                </div>

                                {
                                    permissions && Object.keys(permissions).map((key, index) => {
                                        return(
                                            <div className="mc-tab-card">
                                                <h6 className="mc-tab-card-title">{key}</h6>
                                                <Row>
                                                    {
                                                        permissions[key].map((permission, permissionIndex) => {

                                                            return(
                                                                <Col xl={3} key={permissionIndex}>
                                                                    <div className="mc-table-check">
                                                                        <input 
                                                                            type="checkbox" 
                                                                            name="allCheck"
                                                                            checked={rolePermissionsIds.includes(permission.id)} 
                                                                            onChange={(e)=> {
                                                                                if(e.target.checked){
                                                                                    setRolePermissionsIds([...rolePermissionsIds,permission.id]);
                                                                                }else{
                                                                                    setRolePermissionsIds(rolePermissionsIds.filter(item => item !== permission.id));
                                                                                }
                                                                            }}                                                                        />
                                                                        <p>{permission.name}</p>
                                                                    </div>
                                                                </Col>
                                                            );
                                                        })
                                                    }
                                                </Row>
                                            </div>
                                        );

                                    })

                                }
                                <Row>
                                <Col xl={4}>
                                <ButtonComponent className="mc-btn primary" icon="verified" text={id?t('save_changes'):t('create_new')} onClick={()=>handleClickAction()}/>

                                </Col>
                                <Col xl={4}></Col>
                                {
                                    id &&  <Col xl={4}> <ButtonComponent className="mc-btn red" icon="delete" text={t('delete')} onClick={()=>handleDelete()}/></Col>

                                }
                                </Row>
                                

                            
                    </div>
                </Col>
            </Row>
        </PageLayout>
    )
}